/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/26/2020
Tree Inventory View
**********************************************************/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CultivationModal from '../cult_modal';
import TreeInventoryForm from './tree_inventory_form';
import TreeInventoryDisplay from './tree_inventory_display';
import TreeInventoryTransactionTable from './tree_inventory_transaction_table';
import TreeInventoryTable from './tree_inventory_table';
import { setFormType, prepareInventory, createInventoryRequest, fetchInventory,
  approveInventoryRequest, downloadInventory, setInventoryToEdit, 
  editInventoryRequest, setInventoryToDelete, 
  deleteInventoryRequest } from '../../actions/tree_inventory_actions';
import { fetchFields, fetchEmployees, clearForm } from '../../actions/utils_actions';
import { packageForm } from '../../cult_utils';;
const $ = window.$;

const propTypes = {
  approvers: PropTypes.array,
  approver: PropTypes.object,
  employees: PropTypes.array,
  fields: PropTypes.array,
  formType: PropTypes.string,
  inventory: PropTypes.array,
  inventoryMaster: PropTypes.object,
  inventoryTransactions: PropTypes.array,
  previousInventoryTransactions: PropTypes.array,
  req: PropTypes.object,
  user: PropTypes.object,
  approveInventoryRequest: PropTypes.func,
  clearForm: PropTypes.func,
  createInventoryRequest: PropTypes.func,
  deleteInventoryRequest: PropTypes.func,
  fetchEmployees: PropTypes.func,
  fetchFields: PropTypes.func,
  fetchInventory: PropTypes.func,
  prepareInventory: PropTypes.func,
  setFormType: PropTypes.func,
  downloadInventory: PropTypes.func,
  setInventoryToEdit: PropTypes.func,
  setInventoryToDelete: PropTypes.func,
  editInventoryRequest: PropTypes.func
};

class TreeInventory extends Component {
  componentDidMount() {
    $('#tree-nav').tabs();
    this.props.fetchInventory();
    if (this.props.employees.length === 0) this.props.fetchEmployees();
  }
  render() {
    return (
      <div className="row chemical-reports-view">
        <ul id="tree-nav" className="tabs tabs-fixed-width">
          <li className="tab col s3"><a className="active chemical-tab-nav" href="#treeInventory">Current Inventory</a></li>
          <li className="tab col s3"><a className="chemical-tab-nav" href="#recentTransactions">Recent Transactions</a></li>
          <li className="tab col s3"><a className="chemical-tab-nav" href="#issueAndReceiveInv">Issue & Receive Inventory</a></li>
        </ul>
        <div id="treeInventory">
          <div className="col s12 m12 l12 xl12">
            <div className="card harvest-scrollable">
              <div className="harvest-form-card">
                <TreeInventoryTable inventory={this.props.inventory} inventoryTransactions={this.props.inventoryTransactions}
                  employees={this.props.employees} onClick={this.props.downloadInventory} />
              </div>
            </div>
          </div>
        </div>
        <div id="recentTransactions">
          <div className="col s12 m12 l12 xl12">
          <div className="card harvest-scrollable">
            <div className="harvest-form-card">
              <TreeInventoryTransactionTable user={this.props.user} _inventory={this.props.inventory} inventory={this.props.inventoryTransactions} 
                formType={this.props.formType} fields={this.props.fields} approvers={this.props.approvers} readOnly={false} formId={'tree-inventory-editform'} 
                setFormType={this.props.setFormType} fetchFields={this.props.fetchFields} setInventoryToEdit={this.props.setInventoryToEdit} 
                onClick={this.props.approveInventoryRequest} editInventoryRequest={this.props.editInventoryRequest} 
                setInventoryToDelete={this.props.setInventoryToDelete} deleteInventoryRequest={this.props.deleteInventoryRequest} />
              </div>
            </div>
          </div>
        </div>
        <div id="issueAndReceiveInv">
          <div className="col s12 m12 l12 xl12">
            <TreeInventoryForm formId={'tree-inventory-form'} formType={this.props.formType} fields={this.props.fields}
              approvers={this.props.approvers} setFormType={this.props.setFormType} fetchFields={this.props.fetchFields} />
          </div>
          <div className="col s12">
            <div className="card-footer">
              <a className="waves-effect waves-light btn modal-trigger" href={'#tree-inventory-prepare'}
                onClick={() => this.props.prepareInventory({
                  user: this.props.user,
                  form: packageForm('tree-inventory-form'),
                  formType: this.props.formType
                })}>
                Prepare
              </a>
              <button className="btn btn-flat"
                onClick={() => this.props.clearForm('tree-inventory-form')}>Clear</button>
            </div>
          </div>
          {
            CultivationModal(TreeInventoryDisplay)
            // eslint-disable-next-line
            ({
              id: 'tree-inventory-prepare',
              approver: this.props.approver,
              formType: this.props.formType,
              data: this.props.req,
              employees: this.props.employees,
              previousInventoryTransactions: this.props.previousInventoryTransactions,
              toDelete: false, // TODO: Add
              editingApplication: false, // TODO: Add
              footer: true,
              createOrEdit: true,
              onClick: () => this.props.createInventoryRequest({
                data: this.props.req,
                formType: this.props.formType,
                inventory: this.props.inventory
              })
            })
          }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    approvers: state.cultivation.treeInventory.approvers,
    approver: state.cultivation.treeInventory.req.approver,
    employees: state.cultivation.utils.employees,
    fields: state.cultivation.utils.fields,
    formType: state.cultivation.treeInventory.formType,
    inventory: state.cultivation.treeInventory.inventory,
    inventoryMaster: state.cultivation.treeInventory.req.inventoryMaster,
    inventoryTransactions: state.cultivation.treeInventory.inventoryTransactions,
    previousInventoryTransactions: state.cultivation.treeInventory.req.previousInventoryTransactions,
    req: state.cultivation.treeInventory.req,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    approveInventoryRequest,
    clearForm,
    createInventoryRequest,
    deleteInventoryRequest,
    downloadInventory,
    editInventoryRequest,
    fetchEmployees,
    fetchFields,
    fetchInventory,
    prepareInventory,
    setFormType,
    setInventoryToDelete,
    setInventoryToEdit
  }, dispatch);
}

TreeInventory.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(TreeInventory);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory.js